import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DashboardShellBase from "../../pages/SHARED/components/DashboardShellBase";

const BUTTON_STYLES = {
  textTransform: "none",
  width: "100%",
  height: "152px",
  background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #f8f9fa 100%)",
  color: "#333333",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  border: "1px solid rgba(37, 99, 235, 0.2)",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
};

const Dashboard = ({ title, links }) => {
  const navigate = useNavigate();

  return (
    <DashboardShellBase title={title} variant="legacy">
      {links.map((linkGroup, index) => (
        <Box key={index} display="flex" gap={3} width="100%">
          {linkGroup.map((link, idx) => (
            <Button
              key={idx}
              onClick={() => navigate(link.path)}
              style={{
                ...BUTTON_STYLES,
                transition: "all 0.2s ease-in-out",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 16px rgba(37, 99, 235, 0.15)";
                e.currentTarget.style.background =
                  "linear-gradient(135deg, #e9ecef 0%, #dee2e6 50%, #e9ecef 100%)";
                e.currentTarget.style.borderColor = "rgba(37, 99, 235, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
                e.currentTarget.style.background =
                  "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #f8f9fa 100%)";
                e.currentTarget.style.borderColor = "rgba(37, 99, 235, 0.2)";
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = "scale(0.98)";
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
            >
              {React.cloneElement(link.icon, {
                style: { fontSize: 40, color: "#2563eb" },
              })}
              <Typography variant="h6" mt={2} sx={{ color: "#333333" }}>
                {link.name}
              </Typography>
            </Button>
          ))}
        </Box>
      ))}
    </DashboardShellBase>
  );
};

export default Dashboard;
